const makeMessage = (type: string, id?: string, payload?: any) => ({
  type: id ? `branch_onboarding_${type}_${id}` : `branch_onboarding_${type}`,
  payload,
})

export const fireOnboardingComplete = (callbackUrl?: string, id?: string) => {
  if (callbackUrl) {
    window.location.href = callbackUrl
  } else {
    window.parent.postMessage(makeMessage('complete', id), '*')
  }
}

export const fireAccountCreated = (id?: string, payload?: any) => {
  window.parent.postMessage(makeMessage('accountCreated', id, payload), '*')
}

export const fireOnboardingExited = (id?: string) => {
  window.parent.postMessage(makeMessage('exit', id), '*')
}

export const fireOnboardingLoaded = (id?: string) => {
  window.parent.postMessage(makeMessage('loaded', id), '*')
}
